import React, { useEffect, useState } from "react";
import layout1Icon from "../../../../../../assests/img/layout1.svg";
import layout2Icon from "../../../../../../assests/img/layout2.svg";
import layout3Icon from "../../../../../../assests/img/layout3.svg";
import layout4Icon from "../../../../../../assests/img/layout4.svg";

import InputColor from 'react-input-color';
import {InfoIcon, XIcon} from "assests/GmsIcons";
import Tooltip from "../../../../../../Components/GMS/Rules/Components/Tooltip";
import ToggleButton from "../../../../../../Components/Common/components/Inputs/ToggleButton";
import CustomCSSInput from "./CustomCSSInput";
import { validateCSS } from "./UIBuilderHelper";
import { toast } from 'Components/DesignSystem/Toast/useToast';

const BuilderConfig = ({setBuilderCreated, setBuilderConfigured, setBuilderSaved, updateConfig, uiConfig}:any) => {

    const [uiBuilderConfig, setUiBuilderConfig] = useState<any>({
        name: "",
        template: "layout3",
        responsivePreference: [],
        voiceEnabled: false,
        viewPref: "list",
        platform: "magento",
        navigation: "nonLinear",
        navigationType: "tabs",
        categoryAvailability: "inStock",
        launchWithFirstPage: false,
        showInstockFilter: true,
        allowShareBuild: false,
        shareBuildLabel: 'Share Outfit',
        showPageControls: true,
        themeSettings: {
        },
        customCSS: "",
        selectInStockDefault: false,
    })

    const [colorNew, setColorNew] = useState({
        background: "#ffffff",
        secondaryBackground: "#e8e6e5",
        title: "#000000",
        subtitles: "#000000",
        solidButtonBackground: "#0747a6",
        solidButtonLabel: "#ffffff",
        onlineButton: "#0747a6",
        primaryColor: "#0747a6",
    });

    const convertCamelCaseToString = (stringValue: any) => {return stringValue
        .replace(/([A-Z])/g, (match: any) => ` ${match}`)
        .replace(/^./, (match: any) => match.toUpperCase())
        .trim();
    }

    useEffect(()=>{
        setUiBuilderConfig(uiConfig.customization);
        if(uiConfig?.customization && uiConfig.customization.themeSettings) {
            if(!Object.prototype.hasOwnProperty.call(uiConfig.customization.themeSettings, "primaryColor")) {
                uiConfig.customization.themeSettings.primaryColor = "#0747a6";
            }
            setColorNew(uiConfig.customization.themeSettings)
        }
        else{
            setColorNew({
                background: "#ffffff",
                secondaryBackground: "#e8e6e5",
                title: "#000000",
                subtitles: "#000000",
                solidButtonBackground: "#0747a6",
                solidButtonLabel: "#ffffff",
                onlineButton: "#0747a6",
                primaryColor: "#0747a6",
            })
        }
    }, [])

    const setInputChange = (fieldName: string, name: string) => {
        const config = {...uiBuilderConfig}
        config[fieldName] = name;
        setUiBuilderConfig(config)
    }

    const setResponsivePref = (pref: string) => {
        const config = {...uiBuilderConfig}
        config.responsivePreference = pref;
        setUiBuilderConfig(config)
    }

    const setTemplate = (template: string) => {
        const config = {...uiBuilderConfig}
        config.template = template;
        setUiBuilderConfig(config)
    }

    const setPlatform = (platform: string) => {
        const config = {...uiBuilderConfig}
        config.platform = platform;
        setUiBuilderConfig(config)
    }

    const setNavigation = (navigation: string) => {
        const config = {...uiBuilderConfig}
        config.navigation = navigation;
        setUiBuilderConfig(config)
    }

    const setNavigationType = (navigationType: string) => {
        const config = {...uiBuilderConfig}
        config.navigationType = navigationType;
        setUiBuilderConfig(config)
    }

    const setShowPageControls = (showPageControls: boolean) => {
        const config = {...uiBuilderConfig}
        config.showPageControls = showPageControls;
        setUiBuilderConfig(config)
    }

    const setViewPref = (viewPref: string) => {
        const config = {...uiBuilderConfig}
        config.viewPref = viewPref;
        setUiBuilderConfig(config)
    }

    const handleLaunchWithFirstPageChange = () => {
        const config = {...uiBuilderConfig}
        config.launchWithFirstPage = !(config.launchWithFirstPage ?? false);
        setUiBuilderConfig(config)
    };

    const handleShowInstockFilterChange = () => {
        const config = {...uiBuilderConfig}
        config.showInstockFilter = !(config.showInstockFilter ?? false);
        setUiBuilderConfig(config)
    };

    const handleSelectInStockDefaultChange = () => {
        const config = {...uiBuilderConfig}
        config.selectInStockDefault = !(config.selectInStockDefault ?? false);
        setUiBuilderConfig(config)
    };

    const handleAllowShareBuildChange = () => {
        const config = {...uiBuilderConfig}
        config.allowShareBuild = !(config.allowShareBuild ?? false);
        setUiBuilderConfig(config)
    };

    const handleCssChange = (cssValue: string) => {
        const config = {...uiBuilderConfig}
        config.customCss = cssValue;
        console.log(validateCSS(cssValue), '=====');
        const validationResult = validateCSS(cssValue).isValid;
        const validationError = validateCSS(cssValue).error;
        
        if (validationResult) {
            setUiBuilderConfig(config);
        } 
    }

    useEffect(()=>{
        let config = {...uiBuilderConfig};
        config.themeSettings = colorNew
        setUiBuilderConfig(config)
    }, [colorNew]);

    useEffect(()=>{
        updateConfig(uiBuilderConfig)
        setBuilderCreated(true)
        setBuilderSaved(true)
    }, [uiBuilderConfig]);

    useEffect(() => {
        if(uiConfig.customization && uiConfig.customization.template) setUiBuilderConfig(uiConfig.customization)
        if(uiConfig.customization && uiConfig.customization.themeSettings) setColorNew(uiConfig.customization.themeSettings)
    }, []);

    return(
        <div className="tw-w-[860px] tw-h-auto tw-bg-white tw-rounded tw-shadow tw-border tw-border-neutral-300">
            <div className="tw-text-black tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-mx-4 tw-my-2">Define Interface</div>
            <button aria-label="Close" data-testid="components-builderconfig-button-1" className="tw-relative tw-text-black tw-float-right tw-mx-[24px] tw-bottom-10" onClick={()=>{
                setBuilderCreated(true)
                setBuilderConfigured(true)
                setBuilderSaved(true)
            }}>
                <XIcon />
            </button>
            <div className="tw-w-[861px] tw-h-[0px] tw-border tw-border-zinc-200"></div>
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-none tw-mx-4 tw-mt-[18px] tw-mb-[6px]">UI Builder Name</div>
            <input data-testid="components-builderconfig-input-2" className="tw-shadow tw-appearance-none tw-w-[435px] tw-border tw-rounded tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-accent-hover tw-mx-4 tw-placeholder-slate-500" id="username" type="text" placeholder="Interface 1" value={uiBuilderConfig.name ? uiBuilderConfig.name : ""} onChange={(e)=> setInputChange('name', e.target.value)}/>
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mx-4 tw-mt-[18px] tw-mb-[6px]">Choose Template</div>
            <div className="tw-flex tw-flex-row tw-space-x-4 tw-mx-4 tw-cursor-pointer">
                <img alt="config-1" className={`tw-w-[182px] tw-h-[147px] tw-bg-white tw-rounded tw-shadow tw-border ${uiBuilderConfig.template==='layout1' ? 'tw-border-blue-800' : 'tw-border-neutral-300'}`} src={layout1Icon} />
                <img alt="config-2" className={`tw-w-[182px] tw-h-[147px] tw-bg-white tw-rounded tw-shadow tw-border ${uiBuilderConfig.template==='layout2' ? 'tw-border-blue-800' : 'tw-border-neutral-300'}`} src={layout2Icon} />
                <img data-testid="components-builderconfig-img-1" alt="config-3" className={`tw-w-[182px] tw-h-[147px] tw-bg-white tw-rounded tw-shadow tw-border ${uiBuilderConfig.template==='layout3' ? 'tw-border-blue-800' : 'tw-border-neutral-300'}`} src={layout3Icon} onClick={ () => setTemplate("layout3") } />
                <img data-testid="components-builderconfig-img-2" alt="config-4" className={`tw-w-[182px] tw-h-[147px] tw-bg-white tw-rounded tw-shadow tw-border ${uiBuilderConfig.template==='layout4' ? 'tw-border-blue-800' : 'tw-border-neutral-300'}`} src={layout4Icon} onClick={ () => setTemplate("layout4") } />
            </div>

            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mx-4 tw-mt-[18px] tw-mb-[6px]">Product view preference</div>
            <div className="tw-flex tw-mx-4">
                <div className="tw-flex tw-items-center tw-me-4">
                    <input data-testid="components-builderconfig-input-3" checked={uiBuilderConfig.viewPref !== "grid"} id="pref-radio" type="radio" value="" name="pref-radio-group" onChange={() => setViewPref("list")} className="tw-w-4 tw-h-4 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 focus:tw-ring-accent-hover tw-dark:focus:ring-blue-600 tw-dark:ring-offset-gray-800 focus:tw-ring-2 tw-dark:bg-gray-700 tw-dark:border-gray-600"/>
                    <label htmlFor="pref-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">List</label>
                </div>
                <div className="tw-flex tw-items-center tw-me-4">
                    <input data-testid="components-builderconfig-input-4" checked={uiBuilderConfig.viewPref === "grid"} id="pref-2-radio" type="radio" value="" name="pref-radio-group" onChange={() => setViewPref("grid")} className="bg-gray-100 border-gray-300 tw-w-4 tw-h-4 tw-text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                    <label htmlFor="pref-2-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Grid</label>
                </div>
                {/*<div className="tw-flex tw-items-center tw-me-4">*/}
                {/*    <input checked={uiBuilderConfig.viewPref === "carousel"} id="pref-3-radio" type="radio" value="" name="pref-radio-group" onChange={() => setViewPref("carousel")} className="bg-gray-100 border-gray-300 tw-w-4 tw-h-4 tw-text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>*/}
                {/*    <label htmlFor="pref-3-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Carousel</label>*/}
                {/*</div>*/}
            </div>

            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mx-4 tw-mt-[18px] tw-mb-[6px]">Responsive preference</div>
            <div className="tw-w-[66px] tw-h-5 tw-pr-2.5 tw-bg-white tw-rounded tw-border tw-justify-start tw-items-center tw-gap-2.5 tw-inline-flex tw-mx-4">
                <div className="tw-w-4 tw-h-4 tw-relative">
                    <input data-testid="components-builderconfig-input-5" id="checkbox-web" aria-describedby="checkbox-web" type="checkbox" disabled onChange={()=>setResponsivePref("web")} className="tw-w-4 tw-h-4 tw-left-0 tw-top-0 tw-absolute tw-bg-white tw-rounded tw-border tw-border-blue-800"></input>
                </div>
                <div className="tw-text-blue-950 tw-text-sm tw-leading-tight">Web</div>
            </div>
            <div className="tw-w-[81px] tw-h-5 pr-2.5 tw-bg-white tw-rounded border tw-justify-start tw-items-center tw-gap-2.5 tw-inline-flex">
                <input data-testid="components-builderconfig-input-6" id="checkbox-mobile" aria-describedby="checkbox-mobile" type="checkbox" disabled onChange={()=>setResponsivePref("mobile")} className="tw-w-4 tw-h-4 tw-bg-white tw-rounded tw-border tw-border-neutral-300"></input>
                <div className="tw-text-blue-950 tw-text-sm tw-leading-tight">Mobile</div>
            </div>
            {/* <div className="tw-text-slate-500 tw-text-sm tw-leading-tight tw-mx-4">Chat/Voice</div>
            <div className="tw-mx-4">
                <label className="tw-flex tw-cursor-pointer tw-select-none tw-items-center">
                    <div className="tw-relative">
                    <input type='checkbox' checked={isVoice} onChange={() => {setIsVoice(!isVoice)}} className="tw-sr-only"/>
                    <div className="tw-block tw-h-4 tw-w-7 tw-rounded-full tw-bg-[#E5E7EB]"></div>
                    <div className="tw-dot tw-absolute tw-left-0.5 tw-top-0.5 tw-h-3 tw-w-3 tw-rounded-full tw-bg-white tw-transition"></div>
                    </div>
                </label>
            </div> */}
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mx-4 tw-mt-[18px] tw-mb-[6px]">Platform</div>
            <div className="tw-flex tw-mx-4">
                <div className="tw-flex tw-items-center tw-me-4">
                    <input data-testid="components-builderconfig-input-7" checked={uiBuilderConfig.platform === "shopify"} id="inline-1-radio" type="radio" value="" name="inline-radio-group" onChange={() => setPlatform("shopify")} className="tw-w-4 tw-h-4 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 focus:tw-ring-accent-hover tw-dark:focus:ring-blue-600 tw-dark:ring-offset-gray-800 focus:tw-ring-2 tw-dark:bg-gray-700 tw-dark:border-gray-600"/>
                    <label htmlFor="inline-1-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Shopify</label>
                </div>
                <div className="tw-flex tw-items-center tw-me-4">
                    <input data-testid="components-builderconfig-input-8" checked={uiBuilderConfig.platform === "magento"} id="inline-2-radio" type="radio" value="" name="inline-radio-group" onChange={() => setPlatform("magento")} className="bg-gray-100 border-gray-300 tw-w-4 tw-h-4 tw-text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                    <label htmlFor="inline-2-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Magento</label>
                </div>
                <div className="tw-flex tw-items-center tw-me-4">
                    <input data-testid="components-builderconfig-input-9" checked={uiBuilderConfig.platform === "bigCommerce"} id="inline-3-radio" type="radio" value="" name="inline-radio-group" onChange={() => setPlatform("bigCommerce")} className="bg-gray-100 border-gray-300 tw-w-4 tw-h-4 tw-text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                    <label htmlFor="inline-3-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">BigCommerce</label>
                </div>
                <div className="tw-flex tw-items-center tw-me-4 disabled">
                    <input data-testid="components-builderconfig-input-10" disabled checked={uiBuilderConfig.platform === "custom"} id="inline-4-radio" type="radio" value="" name="inline-radio-group" onChange={() => setPlatform("custom")} className="tw-w-4 tw-h-4 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 focus:tw-ring-accent-hover tw-dark:focus:ring-blue-600 tw-dark:ring-offset-gray-800 focus:tw-ring-2 tw-dark:bg-gray-700 tw-dark:border-gray-600"/>
                    <label htmlFor="inline-4-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-200 tw-font-['Noto Sans'] tw-dark:text-gray-300">Custom</label>
                </div>
            </div>
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mx-4 tw-mt-[18px] tw-mb-[6px]">Navigation</div>
            <div className="tw-flex tw-mx-4">
                <div className="tw-flex tw-items-center tw-me-4">
                    <input data-testid="components-builderconfig-input-11" checked={uiBuilderConfig.navigation !== "linear"} id="nav-inline-radio" type="radio" value="" name="nav-inline-radio-group" onChange={() => setNavigation("nonLinear")} className="tw-w-4 tw-h-4 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 focus:tw-ring-accent-hover tw-dark:focus:ring-blue-600 tw-dark:ring-offset-gray-800 focus:tw-ring-2 tw-dark:bg-gray-700 tw-dark:border-gray-600"/>
                    <label htmlFor="nav-inline-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Non-Linear</label>
                </div>
                <div className="tw-flex tw-items-center tw-me-4">
                    <input data-testid="components-builderconfig-input-12" checked={uiBuilderConfig.navigation === "linear"} id="nav-inline-2-radio" type="radio" value="" name="nav-inline-radio-group" onChange={() => setNavigation("linear")} className="bg-gray-100 border-gray-300 tw-w-4 tw-h-4 tw-text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                    <label htmlFor="nav-inline-2-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Linear</label>
                </div>
            </div>
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mx-4 tw-mt-[18px] tw-mb-[6px]">Navigation type</div>
            <div className="tw-flex tw-mx-4">
                <div className="tw-flex tw-items-center tw-me-4">
                    <input data-testid="components-builderconfig-input-13" checked={uiBuilderConfig.navigationType === "tabs"} id="navType-inline-radio" type="radio" value="" name="navType-inline-radio-group" onChange={() => setNavigationType("tabs")} className="tw-w-4 tw-h-4 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 focus:tw-ring-accent-hover tw-dark:focus:ring-blue-600 tw-dark:ring-offset-gray-800 focus:tw-ring-2 tw-dark:bg-gray-700 tw-dark:border-gray-600"/>
                    <label htmlFor="navType-inline-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Tabs</label>
                </div>
                <div className="tw-flex tw-items-center tw-me-4">
                    <input data-testid="components-builderconfig-input-14" checked={uiBuilderConfig.navigationType === "stepper"} id="navType-inline-2-radio" type="radio" value="" name="navType-inline-radio-group" onChange={() => setNavigationType("stepper")} className="bg-gray-100 border-gray-300 tw-w-4 tw-h-4 tw-text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                    <label htmlFor="navType-inline-2-radio" className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">Stepper</label>
                </div>
            </div>
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mx-4 tw-mt-[18px] tw-mb-[6px]">Footer Navigation Bar</div>
            <div className="tw-flex tw-mx-4 tw-items-center">
                <div className="tw-text-black tw-text-sm tw-leading-tight tw-mr-2">Show</div>
                <ToggleButton
                    name="FooterNavigationBarToggle"
                    value={uiBuilderConfig.showPageControls ?? true}
                    onChange={(e) => setShowPageControls(e.target.checked)}
                />
            </div>
            {/* {uiConfig.builderSaved === true && (<div> */}
            { uiBuilderConfig.platform === "custom" ? <>
                <div
                    className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mx-4 tw-mt-[18px] tw-mb-[6px]">Category
                    availability
                </div>
                <div className="tw-flex tw-mx-4">
                    <div className="tw-flex tw-items-center tw-me-4">
                        <input data-testid="components-builderconfig-input-15" checked={uiBuilderConfig.categoryAvailability === "inStock"}
                               id="catAvailType-inline-radio" type="radio" value=""
                               name="catAvailType-inline-radio-group"
                               onChange={() => setInputChange('categoryAvailability', 'inStock')}
                               className="tw-w-4 tw-h-4 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 focus:tw-ring-accent-hover tw-dark:focus:ring-blue-600 tw-dark:ring-offset-gray-800 focus:tw-ring-2 tw-dark:bg-gray-700 tw-dark:border-gray-600"/>
                        <label htmlFor="catAvailType-inline-radio"
                               className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">In
                            Stock</label>
                    </div>
                    <div className="tw-flex tw-items-center tw-me-4">
                        <input data-testid="components-builderconfig-input-16" checked={uiBuilderConfig.categoryAvailability === "inStockBackOrderAll"}
                               id="catAvailType-inline-2-radio" type="radio" value=""
                               name="catAvailType-inline-radio-group"
                               onChange={() => setInputChange('categoryAvailability', 'inStockBackOrderAll')}
                               className="bg-gray-100 border-gray-300 tw-w-4 tw-h-4 tw-text-blue-600 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                        <label htmlFor="catAvailType-inline-2-radio"
                               className="tw-ms-2 tw-text-sm tw-font-medium tw-text-gray-900 tw-dark:text-gray-300 tw-font-['Noto Sans']">InStock,
                            BackOrder, All</label>
                    </div>
                </div>
            </> : null}
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-none tw-mx-4 tw-mt-[18px] tw-mb-[6px]">In-stock status label</div>
            <input data-testid="components-builderconfig-input-17"
                className="tw-shadow tw-appearance-none tw-w-[435px] tw-border tw-rounded tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-accent-hover tw-mx-4 tw-placeholder-slate-500"
                type="text" placeholder="e.g., In-stock, Available now"
                value={uiBuilderConfig.inStockStatusLabel === undefined ? "In stock" : uiBuilderConfig.inStockStatusLabel} onChange={(e) => setInputChange('inStockStatusLabel', e.target.value)}/>

            <div className="tw-text-slate-500 tw-text-sm  tw-leading-none tw-mx-4 tw-mt-[18px] tw-mb-[6px]">Backorder status label</div>
            <input data-testid="components-builderconfig-input-18"
                className="tw-shadow tw-appearance-none tw-w-[435px] tw-border tw-rounded tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-accent-hover tw-mx-4 tw-placeholder-slate-500"
                type="text" placeholder="e.g., Available for back order"
                value={uiBuilderConfig.availableForBackorderStatusLabel === undefined ? "Available for back order" : uiBuilderConfig.availableForBackorderStatusLabel} onChange={(e) => setInputChange('availableForBackorderStatusLabel', e.target.value)}/>

            <div className="tw-text-slate-500 tw-text-sm  tw-leading-none tw-mx-4 tw-mt-[18px] tw-mb-[6px]">In-stock filter label</div>
            <input data-testid="components-builderconfig-input-19"
                className="tw-shadow tw-appearance-none tw-w-[435px] tw-border tw-rounded tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-accent-hover tw-mx-4 tw-placeholder-slate-500"
                type="text" placeholder="e.g., Show In Stock Only"
                value={uiBuilderConfig.availabilityLabel === undefined ? "Show In Stock Only" : uiBuilderConfig.availabilityLabel} onChange={(e) => setInputChange('availabilityLabel', e.target.value)}/>

            {uiBuilderConfig.platform === "custom" && uiBuilderConfig.categoryAvailability === 'inStockBackOrderAll' ? <>
                <div className="tw-text-slate-500 tw-text-sm  tw-leading-none tw-mx-4 tw-mt-[18px] tw-mb-[6px]">Back order label</div>
                <input data-testid="components-builderconfig-input-20"
                    className="tw-shadow tw-appearance-none tw-w-[435px] tw-border tw-rounded tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-accent-hover tw-mx-4 tw-placeholder-slate-500"
                    type="text" placeholder="e.g., Available for backorder"
                    value={uiBuilderConfig.availableForBackorder === undefined ? "Available for backorder" : uiBuilderConfig.availableForBackorder}
                    onChange={(e) => setInputChange('availableForBackorder', e.target.value)}/></> : null}

            {uiBuilderConfig.platform === "custom" && uiBuilderConfig.categoryAvailability === 'inStockBackOrderAll' ? <>
                <div className="tw-text-slate-500 tw-text-sm  tw-leading-none tw-mx-4 tw-mt-[18px] tw-mb-[6px]">All label</div>
                <input data-testid="components-builderconfig-input-21"
                    className="tw-shadow tw-appearance-none tw-w-[435px] tw-border tw-rounded tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-accent-hover tw-mx-4 tw-placeholder-slate-500"
                    type="text" placeholder="e.g., Show All"
                    value={uiBuilderConfig.showAll === undefined ? "Show All" : uiBuilderConfig.showAll}
                    onChange={(e) => setInputChange('showAll', e.target.value)}/></> : null}
            <div className="tw-flex-auto tw-flex tw-items-center tw-mt-[18px] tw-mb-[6px]">
                <div
                    className="tw-text-slate-500 tw-text-sm tw-leading-none tw-ms-4 tw-me-2">{'Launch with first page'}</div>
                <Tooltip
                    text={'When enabled, this setting will ensure that users always land on the first page of the builder whenever the builder is launched, regardless of the product already added to the builder. If disabled, users will land on the next page, based on product already selected.'}>
                    <InfoIcon/>
                </Tooltip>
            </div>
            <div className="tw-flex-auto tw-flex tw-items-center tw-mx-4">
                <ToggleButton
                    name="LaunchWithFirstPage"
                    value={uiBuilderConfig.launchWithFirstPage ?? false}
                    onChange={(e) => handleLaunchWithFirstPageChange()}
                />
            </div>
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-none tw-ms-4 tw-me-2 tw-mt-[18px] tw-mb-[4px]">{'Show in-stock filter'}</div>
            <div className="tw-flex-auto tw-flex tw-items-center tw-mx-4">
                <ToggleButton
                    name="ShowInstockFilter"
                    value={uiBuilderConfig.showInstockFilter === undefined ? true : uiBuilderConfig.showInstockFilter ?? false}
                    onChange={(e) => handleShowInstockFilterChange()}
                />
            </div>
            {
                uiBuilderConfig.showInstockFilter !== false ? <>
                    <div className={`tw-text-slate-500 tw-text-slate-500 tw-text-sm  tw-leading-none tw-ms-4 tw-me-2 tw-mt-[18px] tw-mb-[4px]`}>Select by default</div>
                    <div className="tw-flex-auto tw-flex tw-items-center tw-mx-4">
                        <ToggleButton
                            name="SelectByDefault"
                            value={uiBuilderConfig.selectInStockDefault === undefined ? false : uiBuilderConfig.selectInStockDefault ?? false}
                            onChange={(e) => handleSelectInStockDefaultChange()}/>
                    </div>
                </> : null
            }
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-none tw-ms-4 tw-me-2 tw-mt-[18px] tw-mb-[4px]">{'Allow sharing of Build'}</div>
            <div className="tw-flex-auto tw-flex tw-items-center tw-mx-4">
                <ToggleButton
                    name="AllowShareBuild"
                    value={uiBuilderConfig.allowShareBuild === undefined ? false : uiBuilderConfig.allowShareBuild ?? false}
                    onChange={(e) => handleAllowShareBuildChange()}
                />
            </div>
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-none tw-ms-4 tw-me-2 tw-mt-[18px] tw-mb-[4px]">{'Custom CSS'}</div>
            <div className="tw-flex-auto tw-flex tw-items-center tw-mx-4">
                <CustomCSSInput 
                    initialValue={uiBuilderConfig?.customCss}
                    onChange={handleCssChange}  />
            </div>
            {
                uiBuilderConfig.allowShareBuild === true ? <>
                    <div className="tw-text-slate-500 tw-text-sm  tw-leading-none tw-mx-4 tw-mt-[18px] tw-mb-[6px]">Share Build Label</div>
                    <input data-testid="components-builderconfig-input-22"
                        className="tw-shadow tw-appearance-none tw-w-[435px] tw-border tw-rounded tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-accent-hover tw-mx-4 tw-placeholder-slate-500"
                        type="text" placeholder="e.g., Share Outfit"
                        value={uiBuilderConfig.shareBuildLabel === undefined ? "Share Outfit" : uiBuilderConfig.shareBuildLabel}
                        onChange={(e) => setInputChange('shareBuildLabel', e.target.value)}/></> : null
            }

            {<div>
            <div className="tw-text-slate-500 tw-text-sm  tw-leading-tight tw-mx-4 tw-mt-[18px]">Theme settings</div>
            <div className="tw-grid tw-grid-cols-3 tw-gap-4 tw-mx-4 tw-my-4">
                <div className="tw-grid tw-col-span-2 tw-grid-cols-2 tw-gap-4">
                    {
                        Object.entries(colorNew).sort().map(([key, val]) => <div key={key} className="tw-d-inline-block">
                            <InputColor
                                initialValue={val}
                                onChange={colorPicked => {
                                    switch (key) {
                                        case 'background': {
                                            setColorNew({...colorNew, background: colorPicked.hex});
                                            break;
                                        }
                                        case 'secondaryBackground': {
                                            setColorNew({...colorNew, secondaryBackground: colorPicked.hex});
                                            break;
                                        }
                                        case 'title': {
                                            setColorNew({...colorNew, title: colorPicked.hex});
                                            break;
                                        }
                                        case 'subtitles': {
                                            setColorNew({...colorNew, subtitles: colorPicked.hex});
                                            break;
                                        }
                                        case 'solidButtonBackground': {
                                            setColorNew({...colorNew, solidButtonBackground: colorPicked.hex});
                                            break;
                                        }
                                        case 'solidButtonLabel': {
                                            setColorNew({...colorNew, solidButtonLabel: colorPicked.hex});
                                            break;
                                        }
                                        case 'onlineButton': {
                                            setColorNew({...colorNew, onlineButton: colorPicked.hex});
                                            break;
                                        }
                                        case 'primaryColor': {
                                            setColorNew({...colorNew, primaryColor: colorPicked.hex});
                                            break;
                                        }
                                        default: {
                                            break;
                                        }
                                    }
                                }}
                                placement="right"
                            />
                            <div className="col-1 d-inline-block tw-ml-2 tw-justify-content-end tw-align-items-end">
                                <div
                                    className="tw-text-blue-950 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-leading-tight tw-w-max">{convertCamelCaseToString(key)}</div>
                                <div
                                    className="tw-text-blue-950 tw-text-xs tw-leading-none tw-mt-2">{val.toUpperCase()}</div>
                            </div>
                        </div>)
                    }
                </div>
                <div className="">
                    <div
                        style={{background: colorNew.background}}
                        className="tw-p-4 bg-white rounded-sm border border-solid border-[color:var(--Shades-of-Grey-20,#DADBDD)] leading-[140%]">
                        <div
                            style={{color: colorNew.title}}
                            className="tw-text-black tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-leading-tight">Title
                        </div>
                        <div
                            style={{color: colorNew.subtitles}}
                            className="tw-text-black tw-text-xs tw-font-medium tw-font-['Noto Sans'] tw-leading-none tw-mt-1">Subtitle
                        </div>
                        <div className="flex gap-3 mt-3.5 tw-mt-4">
                            <div
                                className="tw-mr-2 tw-w-[88px] tw-h-8 tw-px-[22px] tw-py-2 tw-bg-white tw-rounded tw-border tw-border-blue-800 tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex tw-cursor-pointer">
                                <div role="button" data-testid="components-builderconfig-div-3"
                                    className="tw-text-center tw-text-blue-800 tw-text-sm tw-leading-tight tw-cursor-pointer"
                                    onClick={() => ''}>Button
                                </div>
                            </div>
                            <div
                                style={{background: colorNew.solidButtonBackground}}
                                className={`tw-w-[88px] tw-h-8 px-[22px] tw-py-2 tw-rounded tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex tw-cursor-pointer`}>
                                <div role="button" data-testid="components-builderconfig-div-4"
                                    style={{color: colorNew.solidButtonLabel}}
                                    className="tw-text-center tw-text-white tw-text-sm tw-leading-tight tw-cursor-pointer"
                                    onClick={() => ''}>Button
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>}

            <div className='tw-px-4 tw-pt-[18px]'>
                <div className="tw-text-slate-500 tw-text-sm  tw-leading-none tw-mb-[6px]">Custom CSS</div>
                <textarea data-testid="components-builderconfig-textarea-23"
                    id='custom-css-input'
                    className="tw-w-full tw-relative tw-bg-white tw-rounded tw-border tw-border-zinc-200 tw-mt-1 tw-p-2"
                    value={uiBuilderConfig?.customCSS ?? ''}
                    onChange={(e) => setInputChange('customCSS', e.target.value)}
                    placeholder={''}/>
            </div>
            <div className="tw-w-full tw-grid tw-justify-items-end">
                <button data-testid="components-builderconfig-button-24" onClick={() => {
                    setBuilderCreated(true)
                    setBuilderConfigured(true)
                    setBuilderSaved(true)
                }} className="small-filled-btn tw-px-[24px] tw-h-[30px] tw-mx-[12px] tw-my-[18px] tw-mx-4">Done
                </button>
            </div>
        </div>
    )
}

export default BuilderConfig;